import { RerouteService } from "@/common/api.service";
import { NAME_CHECK_STATUS } from "@/utils/namecheck/status";
import { GET_NAMECHECK_INSTITUTIONS, RUN_NAMECHECK } from "./actions.type";
import { SET_ERROR } from "./mutations.type";

/**
 * Standalone "check name" tool reached from the header icon.
 *
 * These actions deliberately do NOT commit ISLOADING: the modal is a place the operator sits and
 * re-checks repeatedly, so the wait is shown inline (button spinner + result skeleton) rather than
 * dropping the app-wide overlay over an open modal on every check.
 *
 * Institution lists are memoised per country for the session — the backend also caches them in
 * Redis, this just avoids a round-trip when the operator toggles back and forth.
 */

const state = {
  errors: null,
  institutionsByCountry: {},
};

const getters = {
  namecheckInstitutions: (state) => (isocode) =>
    state.institutionsByCountry[String(isocode).toUpperCase()] || null,
};

const actions = {
  async [GET_NAMECHECK_INSTITUTIONS](context, isocode) {
    const key = String(isocode).toUpperCase();
    const cached = context.state.institutionsByCountry[key];
    if (cached) return cached;

    RerouteService.init();
    const response = await RerouteService.get(
      `namecheck/institutions?country=${encodeURIComponent(isocode)}`,
    ).catch(({ response }) => response);

    if (response && response.status === 200 && response.data && response.data.details) {
      const details = response.data.details;
      context.commit("setNamecheckInstitutions", { key, details });
      return details;
    }

    context.commit(SET_ERROR, response);
    return null;
  },

  async [RUN_NAMECHECK](context, payload) {
    RerouteService.init();
    const response = await RerouteService.post("namecheck", payload).catch(
      ({ response }) => response,
    );

    if (response && response.status === 200 && response.data && response.data.details) {
      return response.data.details;
    }

    context.commit(SET_ERROR, response);
    // A transport or auth failure is indistinguishable from a partner outage to the operator:
    // both mean "we could not check", so surface it as the same state the backend would return.
    return { status: NAME_CHECK_STATUS.PROVIDER_ERROR };
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  setNamecheckInstitutions(state, { key, details }) {
    state.institutionsByCountry = { ...state.institutionsByCountry, [key]: details };
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
